import { render } from "./AlarmModal.vue?vue&type=template&id=9ded27a8"
import script from "./AlarmModal.vue?vue&type=script&lang=js"
export * from "./AlarmModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__